// extracted by mini-css-extract-plugin
export var dnbSpacing = "ListAllIcons-module--dnb-spacing--82f16";
export var listItemInnerStyle = "ListAllIcons-module--listItemInnerStyle--f8a80";
export var listItemStyle = "ListAllIcons-module--listItemStyle--c58a5";
export var listStyle = "ListAllIcons-module--listStyle--c3339";